<template>
  <div class="productDetail">
    <div class="location">
      <span>当前位置：</span><span>首页</span> &gt; <router-link to="/productlist" tag="span">机电设备</router-link> &gt;
      <span v-text="dataForm.machineName || ''"></span>
    </div>
    <div class="detail-box clearfix">
      <div class="left-detail">
        <Swiper
          :big-img-width="510"
          :big-img-height="400"
          :small-img-width="170"
          :small-img-height="120"
          :is-show-small="true"
          :pic-list="dataPicList"
          :clear-time="clearTime">
        </Swiper>
      </div>
      <div class="right-detail clearfix">
        <h3 v-text="dataForm.machineName || ''"></h3>
        <hr>
        <div class="box-list">
          <p>品牌：{{dataForm.machineBrand}}</p>
          <p>机种：{{dataForm.machineType}}</p>
          <p>型号：{{dataForm.modelNumber}}</p>
          <p>应用行业：{{dataForm.applications}}</p>
          <p>设备特点：{{dataForm.characteristic}}</p>
        </div>
        <div class="box-btn">
          <button @click="handleVisit(dataForm)">预约参观</button>
          <button :disabled="disabledBtn" :class="[disabledBtn? 'disabled-btn':'']" @click="collect">立即收藏</button>
        </div>
      </div>
    </div>
    <div class="tab-box">
      <div id="outer">
        <ul id="tab">
          <li
            v-for="(item,index) in list"
            :key="index"
            :class="{on:index === onIndex}"
            @click="select(index)"
          >{{item.name}}
          </li>
        </ul>
        <div id="content">
          <ul class="article">
            <li v-html="dataForm.description" v-show="0 === onIndex"></li>
            <!--<li v-for="(item,index) in dataForm.html" v-show="index === onIndex" v-html="item"></li>-->
            <li v-html="dataForm.standardProportions" v-show="1 === onIndex"></li>
            <li v-html="dataForm.afterService" v-show="2 === onIndex"></li>
          </ul>
        </div>
      </div>
    </div>
    <Dialog title="提示" ref="dialog">
      <p>您还未登录，是否前往登录？</p>
      <div slot="footer">
        <Button type="primary" @click="dialogClose(1)">确认</Button>
        <Button @click="dialogClose()">取消</Button>
      </div>
    </Dialog>
    <Dialog title="提示" ref="dialog1">
      <p>您已成功收藏</p>
      <div slot="footer">
        <Button type="primary" @click="dialogClose1">确认</Button>
      </div>
    </Dialog>

  </div>
</template>

<script>
  import Swiper from '@/components/swiper/Swiper.vue'
  import Tab from '@/components/tab/Tab.vue'
  import { Dialog, Button } from '../../components'
  import { MachineDetailSrv } from '../../api/productDetail/productList'
  import { collectionSrv } from '../../api/collect'

  export default {
    data() {
      return {
        onIndex: 0,
        show: true,
        clearTime: false,
        disabledBtn:false,
        dataPicList:[],
        dataForm:{},
        list:[
          {name:'设备介绍'},
          {name:'规格配置'},
          {name:'售后服务'}
        ],

      }
    },
    beforeRouteLeave(to, from, next){
      this.clearTime = true;
      next();
    },
    components: {
      Swiper,
      Tab,
      Dialog,
      Button
    },
    methods:{
      handleVisit(obj){
        this.$router.push({ path: 'appointmentvisit?key=',query:obj })
      },
      select(index){
        this.onIndex = index;
      },
      handleDetail(){
        let params = this.$route.query
        MachineDetailSrv(params).then(res=>{
          this.dataForm = res.data
          console.log(this.dataForm,'this.dataForm')
          Array.isArray(res.data.fileList) && res.data.fileList.forEach((item)=>{
            let obj = {};
            obj.imgSrc = item.filePath;
            obj.imgLink = ''
            this.dataPicList.push(obj)
          })
//          console.log(this.dataPicList)
        })
      },
      collect() {
        const useData = this.$storage.get('__USD');
        if(!useData) {
          this.$refs.dialog.open();
          return
        }
        let params = {
          memberId:useData.code,
          collectionNo:this.$route.query.machineNo
        };
        collectionSrv(params).then(res => {
          this.disabledBtn = true
          this.$refs.dialog1.open();
        }).catch(e=>{
          alert(e.resultMsg)
        })
      },
      dialogClose1(){
        this.$refs.dialog1.close();
      },
      dialogClose(l) {
        if(l) {
          this.$router.push({ name: 'login' })
        }
        this.$refs.dialog.close();
      }
    },
    mounted() {
      this.handleDetail()
    }
  }

</script>
<style lang="less" type="text/scss">

  .productDetail {
    width: 1200px;
    margin: 0 auto;

    .location {
      padding: 15px 0;
      color: #739cf0;
      border-bottom: 3px solid #DDDDDD;
      margin-bottom: 10px;

      span:last-child {
        color: #5e5c5c;
      }

      span:first-child {
        color: #6e6e6e;
      }

    }
    h2 {
      color: red;
    }

    .detail-box {
      margin: 30px 0 0;

      .left-detail {
        padding: 15px;
        border: 1px solid #ddd;
        float: left;
        width: 542px;
      }

      .right-detail {
        float: left;
        width: 658px;
        padding-left: 60px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin-top: 50px;

        h3 {
          /*margin-top: 45px;*/
          margin-bottom: 30px;
          font-size: 22px;
        }

        .box-list {
          font-size: 17px;

          p {
            margin-top: 25px;
          }

        }
        .box-btn {
          margin-top: 40px;
          display: inline-block;

          button {
            cursor: pointer;
            width: 150px;
            height: 50px;
            color: white;
            border: none;
            font-size: 16px;

            &:first-child {
              background-color: #7FB6F8;
            }

            &:last-child {
              background-color: #F6A742;
              margin-left: 30px;
            }

          }
        }
      }
    }
    .tab-box {
      width: 100%;
      margin-top: 20px;

      #tab {
        overflow: hidden;
        zoom: 1;
        background: #f7f7f7;
        border-bottom: 3px solid #71b7fe;

        li {
          float: left;
          height: 52px;
          cursor: pointer;
          line-height: 55px;
          list-style-type: none;
          padding: 0 20px;
          font-size: 17px;
        }

        .on {
          background-color: #71b7fe;
          color: white
        }

      }
      #content {

        .article {
          line-height: 25px;
          padding: 15px 0;
        }

      }
    }
  }
  .disabled-btn{
    background-color: gray !important;
    color:#fff;
  }


</style>



// WEBPACK FOOTER //
// src/views/productDetail/ProductDetail.vue